import { RoomPanelModalProvider } from '@/app/components/hotel-detail/rooms/RoomPanelModalProvider';
import { ChangeTransportDetailsModalProvider } from '@/app/components/hotel-detail/changeTransport/ChangeTransportDetailsModalProvider';
import { ChangeTransportModalProvider } from '@/app/components/hotel-detail/evo/transport/EvoChangeTransportCard/ChangeTransportModalProvider';
import { ChangeTransportModal } from '@/app/components/hotel-detail/evo/transport/EvoChangeTransportCard/ChangeTransportModal';
import { EvoModalsProvider } from '@/app/components/hotel-detail/evo/EvoModalsProvider';
import { EvoModals } from '@/app/components/hotel-detail/evo/EvoModals';
import { EvoChangeTransportDetailsModal } from '@/app/components/hotel-detail/evo/EvoChangeTransportDetailsModal';

export function EvoDetailsProviders(props: React.HTMLAttributes<HTMLElement>) {
  return (
    <RoomPanelModalProvider>
      <ChangeTransportModalProvider>
        {/* MPH-969: the only flight-details provider of the page. The change-flight drawer reads it
            from here too, so one isOpen drives the details modal wherever it is opened from, and
            the ?modal= stack has a single owner for it. */}
        <ChangeTransportDetailsModalProvider>
          <ChangeTransportModal />
          <EvoChangeTransportDetailsModal />
          <EvoModalsProvider>
            <EvoModals />
            {props.children}
          </EvoModalsProvider>
        </ChangeTransportDetailsModalProvider>
      </ChangeTransportModalProvider>
    </RoomPanelModalProvider>
  );
}
